import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'referencesName';

export class ReferencesName extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
